import { useEffect } from "react";
import { ColumnsType } from "antd/es/table";
import { Table } from "antd";
import { formatLocalDateTime } from "@/utils/utils";
import { TradeTypeEnum } from "@/types/FmsEnums";
import { billDataModel } from "./billDataModel";
import { InvoiceBill } from "@/views/invoice/manage/InvoiceManageTypes";
import { invoiceModel } from "@/views/invoice/manage/InvoiceModel";
import TextPriviewImage from "@/components/Custom/TextPriviewImage";
import BillDetailRender from "@/views/invoice/manage/BillDetailRender";

export function BillDataTable() {

    const { imageUrl } = invoiceModel();
    const {
        dataSource, loadData, onSearch, pgCfg, payMethodLabels,
        selectedRowKeys, setSelectedRowKeys,
        selectedData, setSelectedData,
        buttonDisableCheck
    } = billDataModel();

    const columns: ColumnsType<InvoiceBill> = [
        {
            title: '序号',
            align: "center",
            width: 40,
            render: (v, r, i) => i + 1
        },
        {
            title: '账单编码',
            dataIndex: 'code',
            align: "center",
            width: 100,
        },
        {
            title: '单据编号',
            dataIndex: 'tradeCode',
            align: "center",
            width: 80,
            ellipsis: true,
            render: (t, r) => BillDetailRender(t, r.branch ?? '', r.tradeCode ?? '', r.tradeTypeCode ?? '')
        },
        {
            title: '单据金额',
            dataIndex: 'billAmount',
            width: 50,
            ellipsis: true,
            align: "center",
            // render: (text, record) => (
            //     record.tradeTypeCode === TradeTypeEnum.SALE_RETURN ||
            //     record.tradeTypeCode === TradeTypeEnum.PURCHASE_RETURN ||
            //     record.tradeTypeCode === TradeTypeEnum.BILL_FAVORABLE) ? Math.abs(text) : text
        },
        {
            title: '开票状态',
            dataIndex: 'invoiceStatus',
            align: "center",
            width: 50,
            render: (v) => v === 0 ? '未开票' : v === 1 ? '已开票' : ''
        },
        {
            title: '开票时间',
            dataIndex: 'invoiceTime',
            align: "center",
            width: 100,
        },
        {
            title: '发票号码',
            dataIndex: 'invoiceNum',
            align: "center",
            width: 100,
            ellipsis: true,
            render: (text, record) => {
                return (
                    <TextPriviewImage text={text} previewList={record.invoiceMd5?.split(",")} imageUrl={imageUrl} />
                )
            },
        },
        {
            title: '发票类型',
            dataIndex: 'invoiceTypeCode',
            align: "center",
            width: 80,
            render: (v: any, r: any, i: number) =>
                v == 'invoice-type.no' ? '无票' :
                    v == 'invoice-type.vat-ordinary' ? '增值税普通发票' :
                        v == 'invoice-type.vat-special' ? '增值税专用发票' : '',
        },
        {
            title: '发票上传时间',
            dataIndex: 'invoiceUploadTime',
            align: "center",
            width: 100,
            render: (e => formatLocalDateTime(e))
        },
        {
            title: '无票申请状态',
            dataIndex: 'invoiceApplyStatus',
            align: "center",
            width: 70,
            render: (v) => v === 0 ? '审核中' : v === 1 ? '审核通过' : v === 2 ? '审核驳回' : ''
        },
        {
            title: '支付类型',
            dataIndex: 'payType',
            align: "center",
            width: 70,
            ellipsis: true,
            render: v => payMethodLabels[v] ?? ''
        },
        {
            title: '账户类型',
            dataIndex: 'accountTypeName',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '收款状态',
            dataIndex: 'status',
            align: "center",
            width: 50,
            render: (v) => v === 0 ? '初始' : v === 1 ? '已记账' : v === 2 ? '已核销' : ''
        }
    ];

    useEffect(() => {
        onSearch();
    }, [])

    useEffect(() => {
        buttonDisableCheck();
    }, [selectedRowKeys])

    const onRow = (record: InvoiceBill) => {
        let findIndex = selectedRowKeys.indexOf(record.key);
        let newSelectedRowKeys = [...selectedRowKeys];
        let newSelectedData = selectedData;
        if (findIndex === -1) {
            newSelectedRowKeys.push(record.key);
            newSelectedData.push(record);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            newSelectedData.splice(findIndex, 1);
        }
        setSelectedRowKeys(newSelectedRowKeys);
        setSelectedData(newSelectedData);
    };

    return (
        <Table
            rowKey={record => record.key}
            rowSelection={{
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.key);
                    let newSelectedData = selectedData;
                    if (selected) {
                        for (var i = 0; i < changeRows.length; i++) {
                            let findIndex = selectedRowKeys.indexOf(changeRows[i].key)
                            if (findIndex == -1) {
                                newSelectedData.push(changeRows[i]);
                            }
                        }
                        setSelectedData(newSelectedData);
                        setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                    }
                    else {
                        let spliceArray: number[] = [];
                        for (var i = 0; i < changeRows.length; i++) {
                            let findIndex = selectedRowKeys.indexOf(changeRows[i].key)
                            if (findIndex != -1) {
                                spliceArray.push(i);
                            }
                        }
                        spliceArray = spliceArray.reverse();
                        for (var i = 0; i < spliceArray.length; i++) {
                            newSelectedData.splice(spliceArray[i], 1);
                        }
                        setSelectedData(newSelectedData);

                        setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                    }
                },
                onSelect: (record, selected, selectedRows) => onRow(record),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            scroll={{ x: 'max-content', y: "calc(100vh - 446px)" }}
        />
    )
}

